import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import browserHistory from 'shared/history';
import StudentsTable from './Table';
import {STUDENTS_LOADING_IDENTIFIER, fetchSearchResults} from 'educator/actions/students';
import {
  addStudentsToCaseload,
  handleSelectCaseload,
  handleSelectAllCaseloads,
  removeStudentFromCaseload,
} from 'educator/actions/caseload';

export const mapStateToProps = ({
  loading,
  caseloadStudentIds,
  students,
  educator: {type, isVerified, institution},
  studentSearchOptions: {sortDirection, field, limit, skip, resultsCount},
}) => ({
  loading: loading[STUDENTS_LOADING_IDENTIFIER],
  caseloadStudentIds,
  students,
  educatorType: type,
  isVerified: isVerified,
  sortDirection,
  sortField: field,
  resultsCount,
  limit,
  skip,
  institution,
});

export const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      addStudentsToCaseload,
      handleSelectCaseload,
      handleSelectAllCaseloads,
      removeStudentFromCaseload,
    },
    dispatch
  ),
  goToFirstPage: () => browserHistory.push(`${window.location.pathname}?page=1`),
  fetchStudents: (page = 1) => dispatch(fetchSearchResults({page})),
});

export default connect(mapStateToProps, mapDispatchToProps)(StudentsTable);
